import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Home } from "./pages/Home";
import { Header } from "./layout/Header";
import { Footer } from "./layout/Footer";
import { Information } from "./pages/Information";
import { Preview } from "./pages/Preview";
import { Travel } from "./pages/Travel";
import { Location } from "./pages/Location";
import { Gallery } from "./pages/Gallery";

function App() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/*" element={<Home />} />
        <Route path="/information" element={<Information />} />
        <Route path="/preview" element={<Preview />} />
        <Route path="/location" element={<Location />} />
        <Route path="/travel" element={<Travel />} />
        <Route path="/gallery" element={<Gallery />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
